const LETTERS = "A-Za-zÀ-ÖØ-öø-ÿ"
const WORD_REGEX = new RegExp(`^[${LETTERS}]+(?:['-][${LETTERS}]+)*$`)
const ABBREVIATION_REGEX = new RegExp(`^[${LETTERS}]\\.$`)
const MIN_FULL_WORD_LETTERS = 2

const isFullWord = (token: string): boolean =>
  WORD_REGEX.test(token) && token.replace(/['-]/g, '').length >= MIN_FULL_WORD_LETTERS

export const isValidPersonFullName = (value: string): boolean => {
  const tokens = value.trim().split(/\s+/)

  if (tokens.length < 2) return false
  if (!tokens.every(token => isFullWord(token) || ABBREVIATION_REGEX.test(token))) return false

  return isFullWord(tokens[0]) && isFullWord(tokens[tokens.length - 1])
}
